import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { applyPageMetadata, applyStructuredData } from '../utils/seo';

export default function BartenderJobsMiamiPage() {
  useEffect(() => {
    const cleanupMeta = applyPageMetadata({
      title: 'Bartender Jobs in Miami, FL | BarsConnect',
      description: 'Find bartender shifts and event gigs in Miami, Florida. Join BarsConnect free and get discovered by bars hiring now.',
      canonicalUrl: 'https://barsconnect.com/bartender-jobs-miami-fl',
      robots: 'index,follow',
    });

    const cleanupSchema = applyStructuredData([
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://barsconnect.com/' },
          { '@type': 'ListItem', position: 2, name: 'Bartender Jobs', item: 'https://barsconnect.com/bartender-jobs' },
          { '@type': 'ListItem', position: 3, name: 'Miami, FL', item: 'https://barsconnect.com/bartender-jobs-miami-fl' },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'JobPosting',
        title: 'Bartender Jobs in Miami, FL',
        description: 'Flexible bartender opportunities in Miami, FL through BarsConnect.',
        employmentType: 'CONTRACTOR',
        hiringOrganization: {
          '@type': 'Organization',
          name: 'BarsConnect Partner Bars',
          sameAs: 'https://barsconnect.com',
        },
        jobLocation: {
          '@type': 'Place',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Miami',
            addressRegion: 'FL',
            addressCountry: 'US',
          },
        },
      },
    ]);

    return () => {
      cleanupMeta();
      cleanupSchema();
    };
  }, []);

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8" data-testid="miami-landing-page">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-white mb-3">Bartender Jobs in Miami, FL</h1>
        <p className="text-muted-foreground mb-8">
          Connect with bars hiring in Miami and find your next flexible bartender shift.
        </p>
        <Card className="bg-white/5 border border-white/10">
          <CardContent className="p-6">
            <p className="text-sm text-muted-foreground mb-4">City page is live for SEO discovery and bartender signup growth.</p>
            <div className="flex flex-wrap gap-3">
              <Button asChild><Link to="/register/bartenders">Create Free Bartender Profile</Link></Button>
              <Button asChild variant="outline"><Link to="/bartenders">Browse Bartenders</Link></Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
